import {
	Box,
	IconButton,
	TableRow,
	TableCell,
	Typography,
	styled
} from '@mui/material';
import { ArrowRight } from '@mui/icons-material';
import React from 'react';

const StatusChip = styled(Box)(({ theme }) => ({
	padding: theme.spacing(0.5, 2),
	borderRadius: theme.shape.borderRadius,
	backgroundColor: theme.palette.grey[700],
	color: theme.palette.common.white,
	display: 'inline-block',
	marginRight: theme.spacing(1)
}));

const EntryItem = ({
	entry,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const isSelected = selectedIds.includes(entry.id);

	return (
		<TableRow
			hover
			onClick={() => handleClick(entry)}
			sx={{ cursor: 'pointer' }}
		>
			<TableCell>
				<Typography variant="body2">{entry.user.first_name}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body2">{entry.user.last_name}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body2">{entry.user.country}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body2">{entry.user.age}</Typography>
			</TableCell>
			<TableCell align="right">
				{entry.status === 'approved' && (
					<StatusChip>
						<Typography variant="body2">Shortlisted</Typography>
					</StatusChip>
				)}
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleClick(entry);
					}}
				>
					<ArrowRight />
				</IconButton>
			</TableCell>
		</TableRow>
	);
};

export default EntryItem;
